import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import {
  beneLookUp,
  resetInEdit,
  resetVerification,
} from "../../../../../redux/features/verifyPAN/verifyPAN";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import CommonToast from "../../../../../components/_utils/CommonToast";
// import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import {
  getSpecificFieldForceAccount,
  filedForceApproval,
  filedForceDeniedAccount,
} from "../../../../../redux/features/accounts/fieldForceAccount";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import globalText from "../../../../../utils/globalText";
import ICONS from "../../../../../assets/Icons";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";

const FieldForceAccountEditPanSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [actionLoading, setActionLoading] = useState("");
  const isActionLoading = actionLoading !== "";
  const [isFocused, setIsFocused] = useState(false);

  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];
  const [previousAssociated, setPreviousAssociated] = useState(0);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
  });
  const services = useSelector((state) => state.refreshToken.services);
  useEffect(() => {
    dispatch(resetVerification());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchFieldForcePANSuccessDetail = async () => {
      let response = await dispatch(getSpecificFieldForceAccount({ id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchFieldForcePANSuccessDetail();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const storedValue = localStorage.getItem("haveAssociated");
    if (storedValue !== null) {
      setPreviousAssociated(JSON.parse(storedValue));
    }
  }, []);

  const { beneLookData } = useSelector((state) => state.verify);
  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
  } = useSelector((state) => state.fieldForceAccount);

  const fieldForceAccount = useMemo(
    () => getSpecificFieldForceAccountData?.field_force_accounts?.[0] || {},
    [getSpecificFieldForceAccountData],
  );

  useEffect(() => {
    if (fieldForceAccount && Object.keys(fieldForceAccount).length > 0) {
      const { id, name, bank_name, bank_acc_no, ifsc_code, category, pan_no } =
        fieldForceAccount;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
      });
    }
  }, [fieldForceAccount]);

  const createTxn = () => {
    navigate(
      `/field_force_transaction_dashboard/create_field_force_transaction`,
    );
  };
  const createAccount = () => {
    navigate("/field_force_account_dashboard/create_field_force_account", {
      state: currentAccountDetails,
    });
  };
  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending" && val?.id !== id;
  });
  const showActionError = (response, fallbackText) => {
    toast.dismiss();
    CommonToast({
      text:
        response?.payload?.errors?.field_force_account?.[
          GlobalConfiguration.lengthCheckZero
        ] ||
        response?.payload?.errors?.base?.[
          GlobalConfiguration.lengthCheckZero
        ] ||
        fallbackText,
      variant: "var(--error)",
      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      buttonNeeded: false,
    });
  };

  const accountApproval = async () => {
    setActionLoading("approve");
    toast.dismiss();
    UniversalRefreshToast("Approving account");
    try {
      const response = await dispatch(filedForceApproval(id));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account approved successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
        });
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      } else {
        showActionError(response, "An error occurred while approving account.");
      }
    } catch {
      showActionError(null, "An error occurred while approving account.");
    } finally {
      setActionLoading("");
    }
  };

  const accountRejected = async (reason) => {
    setActionLoading("reject");
    setRejectPopup(false);
    toast.dismiss();
    UniversalRefreshToast("Rejecting account");
    try {
      const response = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData: reason }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account rejected successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
        });
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      } else {
        showActionError(response, "An error occurred while rejecting account.");
      }
    } catch {
      showActionError(null, "An error occurred while rejecting account.");
    } finally {
      setActionLoading("");
    }
  };
  useEffect(() => {
    if (
      !getSpecificFieldForceAccountLoading &&
      getSpecificFieldForceAccountData
    ) {
      dispatch(
        beneLookUp({
          pan_number:
            getSpecificFieldForceAccountData?.field_force_accounts?.[0]?.pan_no,
        }),
      );
    }
    return () => {
      dispatch(resetInEdit());
    };
  }, [
    dispatch,
    getSpecificFieldForceAccountLoading,
    getSpecificFieldForceAccountData,
  ]);
  const buttonRows = [
    ...(services?.includes("FFAAccount") ||
    (services?.includes("Admin") &&
      fieldForceAccount?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                if (isActionLoading) return;
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isDisabled: actionLoading === "approve",
              isLoaderNeeded: true,
              isLoading: actionLoading === "reject",
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                if (isActionLoading) return;
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isDisabled: actionLoading === "reject",
              isLoaderNeeded: true,
              isLoading: actionLoading === "approve",
            },
          ],
        ]
      : []),
    [
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: () => {
          if (isActionLoading) return;
          viewDetailsHandler();
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
        isDisabled: isActionLoading,
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: () => {
          if (isActionLoading) return;
          dashboardHandler();
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
        isDisabled: isActionLoading,
      },
    ],
  ];

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;
    if (length === 0) return "default";
    if (length >= GlobalConfiguration.rejectReasonMinLength) return "verified";
    return focused ? "typing" : "error";
  };

  const handleInputChange = (event) => {
    const sanitizedValue = event.target.value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "")
      .slice(0, 150);

    setDeclineReason(sanitizedValue);
  };
  const shouldShowAssociatedTab =
    previousAssociated === false &&
    (haveApproved !== undefined || havePending !== undefined);

  const approvedAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "approved",
    ) || [];

  const pendingAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "pending" && val?.id !== id,
    ) || [];

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["pan_no", "gstin_detail"];

  const panGstFieldConfig = {
    pan_no: {
      leftSubTitle: "PAN number",
      getTitle: (acc) => acc?.pan_no,
    },
    gstin_detail: {
      leftSubTitle: "GST number (optional)",
      getTitle: (acc) => acc?.gstin_detail,
    },
  };

  const getPanGstSuccessTitle = () => {
    return "Account details updated successfully.";
  };

  const renderPanGstCards = () => {
    return fieldsToShow
      .filter((key) => panGstFieldConfig[key])
      .filter(
        (key) => key !== "gstin_detail" || fieldForceAccount?.gstin_detail,
      )
      .map((key) => {
        const config = panGstFieldConfig[key];
        const title = config.getTitle(fieldForceAccount);
        if (key === "gstin_detail" && !title) return null;
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: title || "Not Given",
                leftSubTitle: config.leftSubTitle,
              },
            ]}
          />
        );
      });
  };

  return (
    <>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Reject account"
            subtext="Provide the reason for rejection."
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              handleInputChange(e);
            }}
            noteText={globalText?.REJECT_POPUP_ACCOUNT_NOTE_TEXT}
            noteColor="text-secondary"
            bulletPoints={[
              "New requests and transactions cannot be created for this account.",
              "Before rejecting this account, reject all associated transactions and requests.",
              "Users can edit the rejected account to update details.",
            ]}
            inputValue={declineReason}
            inputPlaceholder={"Reason"}
            inputOnFocus={() => setIsFocused(true)}
            inputOnBlur={() => setIsFocused(false)}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputFontKind="medium"
            inputIsFullWidth={true}
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="trans"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnOneIsDisabled={isActionLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected(declineReason);
              setDeclineReason("");
            }}
            btnTwoBtnType="submit"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        isLoading={getSpecificFieldForceAccountLoading}
        status="success"
        hoverOption="white"
        title={getPanGstSuccessTitle()}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Updated details">
          <>{renderPanGstCards()}</>
        </TabsWeapperSection>
        {shouldShowAssociatedTab && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            <>
              {haveApproved && approvedAccounts.length > 0 && (
                <>
                  {approvedAccounts.map((val, index) => (
                    <InfoCard
                      key={val?.id || index}
                      bgColor="var(--positive-card)"
                      header={true}
                      borderColor="var(--positive-bg)"
                      rightHeaderText="Approved account"
                      rightHeaderTextColor="var(--text-secondary)"
                      leftHeaderText={val?.name}
                      rows={[
                        {
                          leftTitle: formatAccountNumber(val?.bank_acc_no),
                          leftSubTitle: "Bank account number",
                          ifsc: val?.ifsc_code,
                        },
                      ]}
                    />
                  ))}
                </>
              )}
              {havePending && pendingAccounts.length > 0 && (
                <>
                  {pendingAccounts.map((val, index) => (
                    <InfoCard
                      key={val?.id || index}
                      bgColor="var(--positive-card)"
                      header={true}
                      borderColor="var(--positive-bg)"
                      rightHeaderText="Pending account"
                      rightHeaderTextColor="var(--text-secondary)"
                      leftHeaderText={val?.name?.toLowerCase()}
                      rows={[
                        {
                          leftTitle: formatAccountNumber(val?.bank_acc_no),
                          leftSubTitle: "Bank account number",
                          ifsc: val?.ifsc_code,
                        },
                      ]}
                    />
                  ))}
                </>
              )}
              {!haveApproved &&
                !havePending &&
                (!beneLookData?.beneficiary_accounts ||
                  beneLookData.beneficiary_accounts.length === 0) && (
                  <InfoCard
                    bgColor="var(--positive-card)"
                    rows={[
                      {
                        leftTitle:
                          "  No associated accounts found for the PAN details provided",
                        leftSubTitle:
                          " There are no existing accounts that are associated with the PAN details provided.",
                      },
                    ]}
                  />
                )}
            </>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default FieldForceAccountEditPanSuccess;
